<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f2oyR0/tc-custom/9781504085403.jpg?1726519033301" alt="This image is the cover for the book Replacement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Replacement
      </h1>
      <p class="bookDescription body article font2">
        <b>Your husband had an affair. What do you do when the woman who destroyed your marriage asks for your help? A new thriller from the “hugely engrossing” author (Catherine Ryan Howard, Edgar Award finalist).</b><br/><br/> Lauren Wade hates Jem Carter, and Jem hates her. So, when Lauren gets a message from Jem asking for help, she suspects it’s some sort of attention-seeking stunt by the woman she caught in bed with her husband. Lauren decides to simply alert her ex, Daniel, who thinks Lauren is the one trying to cause trouble.<br/><br/> However, when Jem’s car is found abandoned on a bridge, the police become involved . . .<br/><br/> Lauren knows she’s been a bit erratic. She’s acted in fits of jealousy at times. But she hasn’t harmed Jem. With DS Bekah Bradley closing in, Lauren must make a desperate attempt to find out what happened to Jem—before she becomes a missing person herself . . .<br/><br/> “Wildly entertaining and compelling.” —<i>Daily Mail</i><br/><br/> “I was hooked from the first page. This is a book that pulls you in and demands that you read on. . . . Prepare yourself for a rollercoaster ride of emotions. Can’t recommend highly enough.” —Helen H. Durrant, bestselling author<br/><br/> “Tense and gripping.” —Sanjida Kay, author of <i>My Mother’s Secret</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Ward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf0e54d8